// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__oTLI7","white":"style_white__1nt8W","dark":"style_dark__eEkr3"};